<script setup>
// BonBoZ: hộp chọn hội thoại đích để chuyển tiếp một tin.
//
// Chatwoot gốc không có chuyển tiếp nên cũng không có sẵn bộ chọn hội thoại nào
// dùng lại được. Lọc ngay trên danh sách hội thoại đã nạp sẵn trong store thay
// vì gọi thêm API: người trực gần như luôn chuyển tiếp sang một hội thoại họ
// vừa nhìn thấy, và tìm cục bộ thì không có độ trễ.
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import MessageApi from 'dashboard/api/inbox/message';
import Modal from 'dashboard/components/Modal.vue';
import Avatar from 'next/avatar/Avatar.vue';

const { t } = useI18n();

const hien = ref(false);
const dangGui = ref(false);
const tuKhoa = ref('');
const nguon = ref(null);

const danhSach = useMapGetter('getAllConversations');

const ketQua = computed(() => {
  const k = tuKhoa.value.trim().toLowerCase();
  return danhSach.value
    .filter(c => c.id !== nguon.value?.conversationId)
    .filter(c => !k || (c.meta?.sender?.name || '').toLowerCase().includes(k))
    .slice(0, 30);
});

const mo = payload => {
  nguon.value = payload;
  tuKhoa.value = '';
  hien.value = true;
};

const dong = () => {
  hien.value = false;
  nguon.value = null;
};

const chon = async hoiThoai => {
  if (dangGui.value) return;
  dangGui.value = true;
  try {
    await MessageApi.chuyenTiep(
      nguon.value.conversationId,
      nguon.value.messageId,
      hoiThoai.id
    );
    useAlert(t('BONBOZ.TIN_NHAN.DA_CHUYEN_TIEP'));
    dong();
  } catch (error) {
    useAlert(error?.response?.data?.error || t('BONBOZ.TIN_NHAN.CHUYEN_TIEP'));
  } finally {
    dangGui.value = false;
  }
};

onMounted(() => emitter.on(BUS_EVENTS.BONBOZ_MO_CHUYEN_TIEP, mo));
onUnmounted(() => emitter.off(BUS_EVENTS.BONBOZ_MO_CHUYEN_TIEP, mo));
</script>

<template>
  <Modal v-model:show="hien" :on-close="dong" size="medium">
    <div class="flex flex-col gap-4 p-6">
      <h3 class="text-base font-medium text-n-slate-12">
        {{ $t('BONBOZ.TIN_NHAN.CHON_HOI_THOAI') }}
      </h3>
      <input
        v-model="tuKhoa"
        type="text"
        :placeholder="$t('BONBOZ.TIN_NHAN.TIM_HOI_THOAI')"
        class="px-3 py-2 w-full text-sm rounded-lg border border-n-weak bg-n-alpha-black1 text-n-slate-12"
      />
      <div class="flex overflow-y-auto flex-col gap-1 max-h-80">
        <button
          v-for="c in ketQua"
          :key="c.id"
          type="button"
          :disabled="dangGui"
          class="flex gap-3 items-center px-3 py-2 text-left rounded-lg hover:bg-n-alpha-1 disabled:opacity-50"
          @click="chon(c)"
        >
          <Avatar
            :name="c.meta?.sender?.name || ''"
            :src="c.meta?.sender?.thumbnail || ''"
            :size="28"
            rounded-full
          />
          <span class="flex flex-col min-w-0">
            <span class="text-sm truncate text-n-slate-12">
              {{ c.meta?.sender?.name }}
            </span>
            <span class="text-xs truncate text-n-slate-11">
              {{ c.messages?.[c.messages.length - 1]?.content }}
            </span>
          </span>
        </button>
        <p
          v-if="!ketQua.length"
          class="px-3 py-6 text-sm text-center text-n-slate-11"
        >
          {{ $t('BONBOZ.TIN_NHAN.KHONG_CO_HOI_THOAI') }}
        </p>
      </div>
    </div>
  </Modal>
</template>
